import { Injectable } from '@angular/core';

const USER = 'login_user';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private token: string | null = null;

  setToken(token: string): void {
    this.token = token;
  }

  getToken(): string | null {
    return this.token;
  }

  clearToken(): void {
    this.token = null;
  }

  isLoggedIn(): boolean {
    const user = window.sessionStorage.getItem(USER);
    if (user) {
      return true;
    }
    return false;
  }

  getAuthTokenFromCookie(): string | null {
    const name = 'authToken=';
    const cookieArray = document.cookie.split(';');
    for (const cookie of cookieArray) {
      let c = cookie;
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  setAuthTokenInCookie(token: string): void {
    const cookieOptions: any = {
      httpOnly: true,
      sameSite: 'Strict',
      path: '/',
    };
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7); // Expires in 7 days

    cookieOptions.expires = expirationDate.toUTCString();
    document.cookie = `authToken=${token}; ${Object.entries(cookieOptions).map(([key, value]) => `${key}=${value}`).join('; ')}`;
  }




  // ==========================
  // Merlin Session Methods
  // ==========================

  setMerlinSession(sessionId: string): void {
    sessionStorage.setItem(
      'merlin_session_id',
      sessionId
    );
  }

  getMerlinSession(): string | null {
    return sessionStorage.getItem(
      'merlin_session_id'
    );
  }

  clearMerlinSession(): void {
    sessionStorage.removeItem(
      'merlin_session_id'
    );
  }

}
